
import themes from "@/mixins/themes"
import jobFeatures from "@/mixins/jobFeatures"
import Button from "@/components/base/Button"
import JobTitleGallery from "@/components/job/jobpage/JobTitleGallery"
import JobContainer from "@/components/job/jobpage/JobContainer"
import JobPageOverview from "@/components/job/jobpage/JobPageOverview"
import JobTraineeshipSection from "@/components/job/jobpage/JobTraineeshipSection"
import JobTraineeshipDatePicker from "@/components/job/jobpage/JobTraineeshipDatePicker"
import JobAusbildungSummarySection from "@/components/job/jobpage/JobAusbildungSummarySection"
import { Search } from "@/models/search"
import { mapGetters } from "vuex"
import { mdiChevronLeft } from "@mdi/js"
import { routeToJob } from "@/helpers/routing"

export default {
    name: "JobPagePraktikum",
    components: {
        JobPageOverview,
        JobContainer,
        JobTitleGallery,
        JobTraineeshipDatePicker,
        JobAusbildungSummarySection,
        Button,
        JobTraineeshipSection,
        JobPoweredByOabat: () => import("@/components/job/JobPoweredByOabat"),
    },
    mixins: [themes, jobFeatures],
    props: {
        /** Job object */
        job: {
            type: Object,
            required: true,
        },
        /** hide chat button  */
        hideChat: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["interested-traineeship"],
    data: () => ({
        loadingBack: false,
    }),
    icons: {
        mdiChevronLeft,
    },
    computed: {
        ...mapGetters("routing", ["previousRoute"]),
        titleMedia() {
            if (this.featureTitleGallery) {
                const blockDataItems =
                    this.job.content_blocks?.at(0)?.data.items
                let galleryBlock = this.job.content_blocks?.filter(
                    (i) => i.component === "ContentBlockGallery"
                )
                if (galleryBlock?.length > 0) {
                    return galleryBlock[0].data.media
                }
                return this.getTitleMedia(blockDataItems)
            } else if (this.featureTitleImage) {
                return this.getTitleImageOrVideo()
            }
            return []
        },
        theme() {
            return this.job.theme?.theme
        },
        themeAllowed() {
            return (
                this.theme?.config?.type === "default" ||
                this.featureTheme ||
                this.editorMode
            )
        },
    },
    watch: {
        theme: {
            handler(newTheme) {
                if (this.themeAllowed && newTheme) this.setTheme(newTheme)
                else this.setThemeDefault()
            },
            immediate: true,
        },
    },
    methods: {
        routeToJob,
        getTitleMedia(blockDataItems) {
            let titleMedia = this.getTitleImageOrVideo()
            if (this.featureTitleGallery) {
                let mediaCompare = (a, b) => {
                    const a_video = a.type === "video" ? 1 : 0
                    const b_video = b.type === "video" ? 1 : 0
                    return b_video - a_video
                }
                let contentBlockMedia = blockDataItems
                    ?.filter((i) => i.component !== "ContentBlockGallery")
                    .flatMap((item) => {
                        return (
                            item.data.media ||
                            item.data.images?.concat(item.data.videos)
                        )
                    })
                if (contentBlockMedia)
                    titleMedia = titleMedia.concat(contentBlockMedia)
                titleMedia = titleMedia.sort(mediaCompare).slice(0, 5)
            }
            return titleMedia
        },
        getTitleImageOrVideo() {
            let titleMedia = []
            if (this.featureTitleImage) {
                if (this.job.video) titleMedia.push(this.job.video)
                else if (this.job.image) titleMedia.push(this.job.image)
            }
            return titleMedia
        },
        goBack() {
            if (this.loadingBack) return
            this.loadingBack = true
            if (this.previousRoute) {
                this.$store.dispatch("routing/back")
                this.loadingBack = false
                return
            }

            const businessPrimaryAddress = this.job.business?.primary_address

            if (businessPrimaryAddress) {
                const route = new Search({
                    type: "apprenticeship",
                    location: {
                        slug: "nearby",
                        name: "Umgebung",
                        longitude: businessPrimaryAddress.lng,
                        latitude: businessPrimaryAddress.lat,
                    },
                }).getRoute()
                this.$router.push(route)
                this.loadingBack = false
                return
            }
            this.$router.push("/")
            this.loadingBack = false
        },
    },
}
